/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function EventDescriptionDetailsController($mdDialog, types, utils, payload, showingCallback) {
    var vm = this;

    vm.$onInit = function () {
        vm.eventDescriptionDetailsText = null;

        vm.close = close;

        showingCallback.onShowing = function () {
            if (payload) {
                vm.eventDescriptionDetailsText = payload;
            }
        };

        vm.eventDescriptionDetailsOptions = {
            useWrapMode: true,
            //mode: 'json',
            showGutter: false,
            showPrintMargin: false,
            theme: 'github',
            advanced: {
                enableSnippets: false,
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false
            },
            onLoad: function (_ace) {
                vm.editor = _ace;
            }
        };
    };

    function close () {
        $mdDialog.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/event/event-description-details.controller.js